(function () {
  function shuffle(a){ for(var i=a.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var t=a[i];a[i]=a[j];a[j]=t;} return a; }
  function init(root) {
    if (root.dataset.spInit) return;
    root.dataset.spInit = "1";
    var screen = root.querySelector("[data-screen]");
    if (!screen) return;
    function readJSON(sel){ try { return JSON.parse(root.querySelector(sel).textContent) || null; } catch (e) { return null; } }
    var cfg = readJSON("script.sp-config") || {};
    var allQ = readJSON("script.sp-questions") || [];
    var pool = readJSON("script.sp-pool") || [];
    var pick = parseInt(root.getAttribute("data-pick") || "3", 10);
    var idleLines = cfg.idle || [];
    var votes, step, qs;

    function el(cls, html) { var d = document.createElement("div"); d.className = cls; d.innerHTML = html; return d; }
    function clear() { screen.innerHTML = ""; }
    function line(html, cls) { screen.appendChild(el("sp-ln " + (cls || ""), html)); screen.scrollTop = screen.scrollHeight; }

    function idle() {
      clear();
      idleLines.forEach(function (l) { line(l, "sp-ln--dim"); });
      var b = document.createElement("button");
      b.className = "sp-btn sp-run"; b.type = "button"; b.textContent = cfg.run || "> run signal_scan";
      b.addEventListener("click", startScan);
      var wrap = el("", ""); wrap.appendChild(b); screen.appendChild(wrap);
      screen.appendChild(el("sp-ln sp-ln--dim", (cfg.awaiting || "&gt; awaiting input") + "<span class='sp-cursor'></span>"));
    }

    function startScan() {
      votes = { statement: 0, humor: 0, subtle: 0 }; step = 0;
      qs = shuffle(allQ.slice()).slice(0, pick);
      if (!qs.length) { idle(); return; }
      ask();
    }

    function ask() {
      clear();
      line(cfg.running || "&gt; running signal_scan ...", "sp-ln--dim");
      var cur = qs[step];
      line(cur.q, "sp-ln--cy");
      var wrap = el("sp-btns", "");
      cur.a.forEach(function (opt) {
        var b = document.createElement("button");
        b.className = "sp-btn"; b.type = "button"; b.textContent = "› " + opt[0];
        b.addEventListener("click", function () {
          votes[opt[1]] = (votes[opt[1]] || 0) + 1; step++;
          if (step < qs.length) { ask(); } else { analyze(); }
        });
        wrap.appendChild(b);
      });
      screen.appendChild(wrap);
    }

    function dominant() {
      var best = "statement", bv = -1;
      ["statement", "humor", "subtle"].forEach(function (k) { if ((votes[k] || 0) > bv) { bv = votes[k] || 0; best = k; } });
      return best;
    }

    function analyze() {
      clear();
      line(cfg.analyzing || "&gt; analyzing pattern ...", "sp-ln--dim");
      var v = dominant();
      var ratio = 88 + (votes[v] || 0) * 3 + Math.floor(Math.random() * 4); if (ratio > 99) ratio = 99;
      var diag = (cfg.diag && cfg.diag[v]) || "";
      var matches = pool.filter(function (p) { return p.vibe === v; });
      if (!matches.length) matches = pool;
      var pickP = matches[Math.floor(Math.random() * matches.length)];
      setTimeout(function () {
        line((cfg.ratio || "&gt; signal-ratio:") + " <span class='sp-ln--pu'>" + ratio + "%</span>");
        line((cfg.diagLabel || "&gt; diagnose:") + " " + diag, "sp-ln--cy");
        line(cfg.patchLabel || "&gt; empfohlener patch:", "sp-ln--dim");
        if (pickP) {
          var r = el("sp-result", "");
          r.innerHTML = (pickP.img ? "<img src='" + pickP.img + "' alt=''>" : "") +
            "<div><div class='sp-result__t'>" + pickP.title + "</div>" +
            "<div class='sp-result__patch'>" + pickP.patch + "</div>" +
            "<div class='sp-result__price'>" + pickP.price + "</div>" +
            "<a class='sp-cta' href='" + pickP.url + "'>" + (cfg.ctaLabel || "→ decode") + "</a></div>";
          screen.appendChild(r);
        }
        var again = document.createElement("button");
        again.className = "sp-again"; again.type = "button"; again.textContent = cfg.again || "↻ scan again";
        again.addEventListener("click", startScan);
        screen.appendChild(again);
      }, 650);
    }

    idle();
  }

  function boot() { document.querySelectorAll(".signal-picker").forEach(init); }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
})();
